<template>
  <div class="animated fadeIn">
    <b-modal ref="modal-column" scrollable centered button-size="sm">
      <template #modal-title>
        <i class="fas fa-columns"></i> Quadro - Configuração
      </template>
      <div class="form-group row pt-2 pb-5 mb-5">
        <div class="col-md-12">
          <h5 class="text-third"><i class="fas fa-font" /> Título</h5>
        </div>

        <div id="board-details" class="col-md-12 mb-1">
          <b-form-input v-model="boardName" placeholder="Digite o nome do quadro" />
        </div>

        <div class="col-md-6 pt-4">
          <h5 class="text-third m-0"><i class="fas fa-columns" /> Colunas</h5>
        </div>

        <div class="col-md-6 pt-4 text-right">
          <button type="button" class="btn rounded btn-third btn-sm" @click="onAdd"><i class="fas fa-plus-circle" /> Adicionar</button>
        </div>

        <div class="col-md-12 pb-3 detail">
          Clique e arraste para alterar as posições
        </div>

        <div class="col-md-12">
          <draggable
            :list="localColumns"
            handle=".handle"
            v-on:update="onMoveColumns"
            :animation="200"
            ghost-class="ghost-card"
            class="draggable-area"
          >
            <div
              v-for="(column, index) in localColumns"
              :key="column.id"
              class="draggable-column column-configuration pointer"
            >
              <div class="handle mx-1">
                <i class="fas fa-grip-vertical"/>
              </div>
              <div
                v-if="column.id !== editing.columnID"
                class="editable-area"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <span v-if="column.value" class="text-danger text-bold">{{column.value}}%</span> {{column.name}}

                  <div>
                    <b-dropdown variant="link" size="sm" no-caret class="mx-2">
                    <template slot="button-content">
                      <i v-if="column.eventoColuna.some(event => event !== 0)" class="fas fa-bolt text-warning icone-grid mx-2" v-b-tooltip.hover title="Clique para editar a ação" style="padding-top: 3px;"/>
                      <i v-else class="fas fa-bolt icone-grid mx-2" v-b-tooltip.hover title="Clique para editar a ação" style="padding-top: 3px; color: #818181;"/>
                    </template>
                    <span class="sr-only">Clique para adicionar uma ação</span>
                    <b-dropdown-header><i class="fas fa-bolt"/>&nbsp;&nbsp;&nbsp;<strong>Selecione uma Ação</strong></b-dropdown-header>
                    <b-dropdown-item href="javascript:void(0);" @click.native.capture.stop="onSetAction(column, index, columnEvents.SEM_ACAO)">
                      <i class="fas fa-times text-danger"></i>
                      Sem Ação
                      <i class="fas fa-check pl-3 text-success" v-if="column.eventoColuna.some(event => event === columnEvents.SEM_ACAO)"/>
                    </b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                      <b-dropdown-item href="javascript:void(0);" @click.native.capture.stop="onSetAction(column, index, columnEvents.FOLLOW_UP)">
                        <i class="fas fa-bullhorn text-secondary"></i>
                        Follow Up
                        <i class="fas fa-check pl-3 text-success" v-if="column.eventoColuna.some(event => event === columnEvents.FOLLOW_UP)"/>
                      </b-dropdown-item>
                      <b-dropdown-item href="javascript:void(0);" @click.native.capture.stop="onSetAction(column, index, columnEvents.PRODUTO)">
                        <i class="fas fa-credit-card text-secondary"></i>
                        Novo Produto
                        <i class="fas fa-check pl-3 text-success" v-if="column.eventoColuna.some(event => event === columnEvents.PRODUTO)"/>
                      </b-dropdown-item>
                    <b-dropdown-item href="javascript:void(0);" @click.native.capture.stop="onSetAction(column, index, columnEvents.RESPONSAVEL)">
                      <i class="fas fa-user text-secondary"></i>
                      Responsável
                      <i class="fas fa-check pl-3 text-success" v-if="column.eventoColuna.some(event => event === columnEvents.RESPONSAVEL)"/>
                    </b-dropdown-item>
                  </b-dropdown>
                    <i
                      class="fas fa-edit text-third mx-2"
                      @click.stop.prevent="onEdit(column)"
                    />
                    <i
                      class="fas fa-minus-circle text-danger mx-2"
                      @click="onRemove(column)"
                    />
                  </div>
                </div>
              </div>
              <div
                v-else
                class="w-100 flex flex-column flex-wrap"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <b-form-input
                    :maxlength="20"
                    autofocus
                    id="editing-title"
                    v-model="column.name"
                    style="width: 80%;"
                    class="editing-hidden"
                  />
                  <color-picker
                    v-model="column.color"
                    :position="{ top: '0px', left: '-252px' }"
                  />
                  <div
                    style="width: 10%;"
                    class="d-flex justify-content-end"
                  >
                    <i
                      class="fas fa-check text-success mr-1"
                      @click="onSave(column)"
                    />
                    <i
                      class="fas fa-times-circle text-danger"
                      @click="onCancel(column)"
                    />
                  </div>
                </div>
                <div class="mt-1">
                  <b-form-textarea
                    v-model="column.observacao"
                    placeholder="Digite uma breve descrição sobre a coluna"
                    rows="4"
                    size="5"
                    :noResize="true"
                    class="editing-hidden"
                  />
                </div>
                <div class="mt-1 d-flex align-items-center">
                  <b-form-input
                    id="editing-value"
                    type="text"
                    placeholder="horas"
                    v-model="column.hoursUntilAlert"
                    class="editing-hidden w-25"
                    v-mask="'####'"
                  />
                  <b-form-input
                    id="editing-value"
                    type="text"
                    placeholder="%"
                    v-model="column.value"
                    class="editing-hidden w-25 ml-2"
                    v-mask="'###'"
                  />
                  <b-form-checkbox
                    id="obrigatorio"
                    v-model="column.obrigatorio"
                    name="obrigatorio"
                    class="ml-2"
                  >
                    Passagem Obrigatória
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </draggable>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            type="button"
            class="btn rounded btn-third btn-sm"
            v-on:click="onSave"
            v-b-tooltip.hover
            :title="'Salvar'"
            @click="onSaveBoardColumn"
          >
            <i class="fas fa-check-circle"></i><span class="d-md-down-none"> Salvar</span>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import BoardCollumns from './boardcollumns.js'
export default BoardCollumns
</script>



// WEBPACK FOOTER //
// src/views/private/crm/board/modal/collumns/boardcollumns.vue